import { useCallback, useState } from 'react';
import { useNotification } from '@refinedev/core';
import { httpClient, ROOT_URL } from '../../App';
import { getErrorMessage } from '../../api/error';
import { IBankAccountEdit } from '../../components/modal/admin/editBankAccount';

export const useUpdateBankAccount = (id: number | undefined) => {
  const [isLoading, setIsLoading] = useState(false);
  const { open: openNotification } = useNotification();

  const update = useCallback(
    async (data: IBankAccountEdit) => {
      if (id === undefined) {
        return;
      }
      setIsLoading(true);
      try {
        await httpClient.patch(`${ROOT_URL}/api/v1/bank_accounts`, data);
        setIsLoading(false);
        return true;
      } catch (error) {
        const message = getErrorMessage(error);
        if (openNotification) {
          openNotification({
            key: 'edit_failure',
            message: `Error editing bank account #${id}`,
            description: message || 'Something went wrong',
            type: 'error',
          });
        }
        setIsLoading(false);
        return false;
      }
    },
    [id, openNotification],
  );

  return { update, isLoading };
};
